import { Locale } from './enums'

/**
 * Common timezones to add to the first group of a select so they are at the top
 */
export const CommonTimezones: string[] = [
  'Pacific/Auckland',
  'Australia',
  'UTC',
]

type CountryLocaleOptions = { [key: string]: LocaleOptions }
export type LocaleOptions = { locale: string; currency: string }
export const CountryLocaleOptions: CountryLocaleOptions = {
  default: {
    locale: Locale.NZ,
    currency: 'NZD',
  },
  NZ: {
    locale: Locale.NZ,
    currency: 'NZD',
  },
  AU: {
    locale: Locale.AU,
    currency: 'AUD',
  },
  UK: {
    locale: Locale.UK,
    currency: 'GBP',
  },
  IE: {
    locale: Locale.IE,
    currency: 'EUR',
  },
}
